<template>
  <footer class="footer">
    <div class="container">
      <nav>
          <ul>
              <li>
                  <a>
                      About Us
                  </a>
              </li>
              <li>
                  <a>
                      Cookies
                  </a>
              </li>
              <li>
                  <a>
                      Licenses
                  </a>
              </li>
          </ul>
      </nav>
      <div class="copyright text-center">
          &copy; {{ new Date().getFullYear() }} <a class="btn_link" :href="$currentConfig.unitViewWebsiteUrl">UnitView Ltd</a> | {{$currentConfig.strapline}}
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>

    a.btn_link {
        color: gray !important;
        transition: color .25s;
    }

        a.btn_link:hover {
            color: darkblue !important;
        }
</style>
